export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinatario:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuario no encontrado"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contactos"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Más detalles"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selección de usuarios"])}
}